/* STEEDIU PLUS — Motion (motion.dev)
   Apple-esque choreography: elements ease up + fade as they enter view, grids
   CASCADE with a stagger, and the gateway homepage plays a staggered load-in.
   Fails silent + leaves everything visible if Motion is unavailable. Respects
   reduced-motion. */
(function () {
  'use strict';

  var EASE = [0.16, 1, 0.3, 1]; // easeOutExpo — soft, weighty deceleration
  var RISE = { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] };

  // The head script (snippets/custom-brand.liquid) adds .sd-motion so CSS hides reveal
  // targets before first paint. Drop it once boot has swapped in inline opacity, or right
  // away if Motion is missing, so nothing stays hidden.
  function release() { document.documentElement.classList.remove('sd-motion'); }

  function boot() {
    var M = window.Motion;
    if (!M || !M.inView || !M.animate) return release();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return release();

    // 1) Staggered groups — when the container enters, its children cascade in
    var groups = [
      { container: '.sd-col__grid', child: '.sd-col__cell', stagger: 0 },
      { container: '.sd-pd__rgrid', child: '.sd-pd__rcell', stagger: 0.08 },
      { container: '.sd-pjx__list', child: '.sd-pjx__row', stagger: 0.08 }
    ];
    groups.forEach(function (g) {
      document.querySelectorAll(g.container).forEach(function (cont) {
        var kids = cont.querySelectorAll(g.child);
        if (!kids.length) return;
        for (var i = 0; i < kids.length; i++) kids[i].style.opacity = '0';
        M.inView(cont, function () {
          M.animate(kids, RISE, { duration: 0.6, delay: g.stagger ? M.stagger(g.stagger) : 0, easing: EASE });
        }, { amount: 0.05 });
      });
    });

    // 2) Standalone reveals — single elements, once each
    var solo = document.querySelectorAll(
      '.sd-pjx__masthead, .sd-col__bar, .sd-pd__gallery, .sd-pd__info, ' +
      '.sd-pd__related-title, .sd-ft__top, .sd-ft__wordmark, .sd-ft__base'
    );
    solo.forEach(function (el) {
      el.style.opacity = '0';
      M.inView(el, function (info) {
        var node = info.target;
        if (node.dataset.revealed) return;
        node.dataset.revealed = '1';
        M.animate(node, RISE, { duration: 0.7, easing: EASE });
      }, { amount: 0.12 });
    });

    // 3) Gateway homepage — staggered load-in of the two doors + wordmark
    var gw = document.querySelector('.sd-gw');
    if (gw) {
      var rise = gw.querySelectorAll('.sd-gw__eyebrow, .sd-gw__label, .sd-gw__hint');
      var fade = gw.querySelectorAll('.sd-gw__brand');
      for (var j = 0; j < rise.length; j++) rise[j].style.opacity = '0';
      for (var k = 0; k < fade.length; k++) fade[k].style.opacity = '0';
      M.animate(rise, { opacity: [0, 1], transform: ['translateY(24px)', 'translateY(0)'] },
        { duration: 0.9, delay: M.stagger(0.12, { start: 0.15 }), easing: EASE });
      M.animate(fade, { opacity: [0, 1] }, { duration: 0.8, delay: 0.55, easing: EASE });
    }

    // 4) 404 page — staggered load-in
    var nf = document.querySelectorAll('.sd-404__reveal');
    if (nf.length) {
      for (var n = 0; n < nf.length; n++) nf[n].style.opacity = '0';
      M.animate(nf, RISE, { duration: 0.8, delay: M.stagger(0.1, { start: 0.1 }), easing: EASE });
    }

    release();
  }

  // Accordions: OPEN = native <details> + CSS fade-in; CLOSE = JS fade-out
  // (opacity/transform only — GPU-composited, no layout animation, stays smooth).
  // Easing: easeInOutQuad, matching the open.
  function initAccordions() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('details.sd-pjx__row, details.sd-pd__acc').forEach(function (d) {
      var summary = d.querySelector('summary');
      var panel = d.querySelector('.sd-pjx__detail, .sd-pd__acc-body');
      var inner = d.querySelector('.sd-pjx__detail-inner, .sd-pd__acc-inner');
      if (!summary || !panel || !inner) return;
      var busy = false;

      // Animate real pixel height (border/layout move with it). CSS `height` transition
      // fires a reliable transitionend; hand back to CSS (auto/0) when finished.
      function finish(after) {
        var t;
        var done = function (ev) {
          if (ev && (ev.target !== panel || ev.propertyName !== 'height')) return;
          panel.removeEventListener('transitionend', done);
          clearTimeout(t);
          panel.style.transition = '';
          panel.style.height = '';
          if (after) after();
          busy = false;
        };
        panel.addEventListener('transitionend', done);
        t = setTimeout(function () { done(); }, 620);
      }

      summary.addEventListener('click', function (e) {
        if (reduce || busy) return;
        e.preventDefault();
        busy = true;
        panel.style.transition = 'none';
        if (!d.open) {
          d.open = true;
          panel.style.height = '0px';
          panel.getBoundingClientRect();          // reflow at the start value
          panel.style.transition = '';
          panel.style.height = inner.offsetHeight + 'px';
          finish(null);
        } else {
          d.classList.add('is-closing');            // flip the icon back now, in sync with the collapse
          panel.style.height = inner.offsetHeight + 'px';
          panel.getBoundingClientRect();
          panel.style.transition = '';
          panel.style.height = '0px';
          finish(function () { d.open = false; d.classList.remove('is-closing'); });
        }
      });
    });
  }

  function run() { boot(); initAccordions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
